<template>

    <div class="trax-struct-map" v-show="loaded">
        <div :id="id+'-struct'" class="trax-struct-body">
            <div class="trax-block trax-level-1" v-for="section in sections" :key="section.id" :data-id="section.id">

                <h3 v-if="!registrationId || sections.length>1">{{ section.name }}</h3>

                <trax-ui-struct-actions :bus="bus" :id="id" :data="section" v-if="!registrationId && !userId">
                </trax-ui-struct-actions>

                <div class="btn btn-link btn-just-icon btn-sm float-left" @click="pasteUnitInSection(section)"
                    v-if="pasteAllowed">
                        <i class="material-icons">content_copy</i>
                </div>

                <div class="btn btn-link btn-just-icon btn-sm trax-drag-handler move-1 float-left" 
                    v-if="drag && !registrationId && !userId">
                        <i class="material-icons">drag_indicator</i>
                </div>

                <div class="clearfix"></div>

                <div class="trax-block-body">

                    <div v-for="unit in section.learning_units" :key="unit.id"  :data-id="unit.id" style="cursor:default;"
                        :class="['btn btn-lg btn-default trax-btn-square', {'trax-optional': unit.optional}]"
                        v-if="disabledProgramUnit(unit)">

                        <div class="btn-actions" v-if="editAllowed">
                            <div class="trax-bottom-left-icon dropdown btn-dropdown">
                                <div data-toggle="dropdown" class="dropdown-toggle" :id="'programsessionmenu-'+unit.id">
                                </div>
                                <div class="dropdown-menu" :aria-labelledby="'programsessionmenu-'+unit.id">
                                    <a class="dropdown-item" @click="copyUnit($event, unit)">
                                        Copy
                                    </a>
                                    <a class="dropdown-item" @click="duplicateUnit($event, unit)">
                                        Duplicate
                                    </a>
                                    <a class="dropdown-item trax-optional-item" @click="toggleOptional($event, unit)"
                                        v-if="canToggleOptional(unit)">
                                        <i class="material-icons trax-optional-check" v-if="unit.optional">check</i>
                                        {{ lang.polaris.common.optional }}
                                    </a>
                                </div>
                            </div>
                        </div>

                        <i class="material-icons">{{ learning_unit_icons[unit.type] }}</i>

                        <div class="trax-top-right-icon" v-if="unit.meta.assessment">
                            <i class="material-icons">check</i>
                        </div>

                        <div class="trax-code">{{ unit.code }}</div>
                    </div>

                    <div class="trax-btn-square trax-icon" v-if="hasGroupIcon(section)">
                        + <i class="material-icons">people_outline</i>
                    </div>

                    <button v-for="unit in section.learning_units" :key="unit.id"  :data-id="unit.id" style="cursor:default;"
                        :class="['btn btn-lg btn-default trax-btn-square', {'trax-optional': unit.optional}]" v-if="disabledGroupUnit(unit)">
                        
                        <i class="material-icons">{{ learning_unit_icons[unit.type] }}</i>

                        <div class="trax-top-left-icon" v-if="unit.meta.remedial">
                            <i class="material-icons">replay</i>
                        </div>

                        <div class="trax-top-right-icon" v-if="unit.meta.assessment">
                            <i class="material-icons">check</i>
                        </div>

                        <div class="trax-code">{{ unit.code }}</div>
                    </button>

                    <div class="trax-btn-square trax-icon" v-if="userId">
                        +<i class="material-icons">person_outline</i>
                    </div>

                    <div :id="id+'-struct-'+section.id" :data-id="section.id" style="display:inline;">

                        <div v-for="unit in section.learning_units" :key="unit.id" :data-id="unit.id" :style="editAllowed ? '' : 'cursor:default;'"
                            :class="['btn btn-lg btn-default trax-btn-square', {'trax-optional': unit.optional}]" v-if="editableUnit(unit)">
                            
                            <div class="btn-actions">
                                <div class="float-right trax-btn-corner-icon" v-if="unit.meta.assessment && !editAllowed">
                                    <i class="material-icons">check</i>
                                </div>

                                <div class="float-right trax-btn-corner-icon trax-drag-handler move-2" v-if="drag && editAllowed">
                                    <i class="material-icons">drag_indicator</i>
                                </div>

                                <div class="trax-bottom-left-icon dropdown btn-dropdown" v-if="editAllowed">
                                    <div data-toggle="dropdown" class="dropdown-toggle" :id="'sessionmenu-'+unit.id">
                                    </div>
                                    <div class="dropdown-menu" :aria-labelledby="'sessionmenu-'+unit.id">
                                        <a class="dropdown-item" @click="editMore($event, unit.id)" v-if="canEditMore(unit.id)">
                                            Edit Details
                                        </a>
                                        <a class="dropdown-item" @click="copyUnit($event, unit)" v-if="!registrationId">
                                            Copy
                                        </a>
                                        <a class="dropdown-item" @click="duplicateUnit($event, unit)">
                                            Duplicate
                                        </a>
                                        <a class="dropdown-item" @click="deleteUnit($event, unit)">
                                            Delete
                                        </a>
                                        <a class="dropdown-item trax-optional-item" @click="toggleOptional($event, unit)"
                                            v-if="registrationId">
                                            <i class="material-icons trax-optional-check" v-if="unit.optional">check</i>
                                            {{ lang.polaris.common.optional }}
                                        </a>
                                    </div>
                                </div>
                            </div>

                            <div @click="editUnit($event, unit)">
                                <i class="material-icons">{{ learning_unit_icons[unit.type] }}</i>
                                <div class="trax-code">{{ unit.code }}</div>
                            </div>

                        </div>
                    </div>
                    
                    <button class="btn btn-lg btn-primary trax-btn-square" style="margin-left: -3px;" v-if="editAllowed"
                        @click="addUnit($event, section.id)" data-id="add">
                            <i class="material-icons">add</i>
                    </button>

                </div>
            </div>
        </div>

        <div class="trax-struct-footer" v-if="!registrationId && !userId">
            <button class="btn btn btn-primary" @click="addSection">
                {{ newCategoryLabel }}
            </button>
        </div>
    </div>
    
</template>

<script>
    export default {

        props: {
            bus: null,
            id: null,
            indexId: null,
            drag: null,
            endpoint: null,
            endpointParams: null,
            learningUnitsEndpoint: null,
            newUnitLabel: {default: lang.polaris.form.new_item},
            newCategoryLabel: {default: lang.polaris.form.new_category},
            editAllowed: null,
            editUrlMap: null,
            registrationId: null,
            userId: null
        },

        data: function() {
            return {
                lang: lang,
                loaded: false,
                type: null,
                sections: [],
                sortable: null,
                sortables: [],
                learning_unit_icons: data.learning_unit_icons
            }
        },

        created: function() {
            this.bus.$on(this.id+'-delete-confirmed', this.deleteUnitConfirmed);
            this.bus.$on(this.id+'-edit-created', this.refresh);
            this.bus.$on(this.id+'-edit-updated', this.refresh);
            this.getData();
        },

        updated: function () {
            this.initDrag();
        },

        computed: {

            params: function () {
                var params = this.endpointParams ? this.endpointParams : {};
                if (!params.filters) params.filters = {}
                params.filters.phase_id = this.indexId;
                params.sort = ['order'];
                return params;
            },

            pasteAllowed: function () {
                return this.editAllowed || (!this.registrationId && !this.userId);
            }
        },

        methods: {

            programUnit(unit) {
                return !unit.registration_id;
            },

            groupUnit(unit) {
                return unit.registration_id && !unit.user_id;
            },

            userUnit(unit) {
                return unit.user_id;
            },

            hasGroupUnits(section) {
                if (!this.registrationId) return false;
                for (var index in section.learning_units) {
                    var unit = section.learning_units[index];
                    if (this.groupUnit(unit)) return true;
                }
                return false;
            },

            hasGroupIcon(section) {
                return (this.registrationId && !this.userId) || this.hasGroupUnits(section);
            },

            disabledProgramUnit(unit) {
                return this.programUnit(unit) && this.registrationId;
            },

            canToggleOptional(unit) {
                return this.registrationId && !this.userId && unit.meta && unit.meta.optional;
            },

            toggleOptional(event, unit) {
                var that = this;
                var endpoint = app_url+'polaris/api/front/dashboard/registrations/'+this.registrationId
                    +'/learning-units/'+unit.id+'/optional';

                axios.post(endpoint, {optional: !unit.optional})
                    .then(function (response) {
                        that.refresh();
                    })
                    .catch(function (error) {
                        if (typeof error.response.data == 'string') {
                            that.bus.$emit(that.id+'-toastr-error', error.response.data);
                        }
                        if (typeof error.response.data.message == 'string') {
                            that.bus.$emit(that.id+'-toastr-error', error.response.data.message);
                        }
                    });
            },

            disabledGroupUnit(unit) {
                return this.groupUnit(unit) && this.userId;
            },

            editableUnit(unit) {
                return (this.programUnit(unit) && !this.registrationId)
                    || (this.groupUnit(unit) && this.registrationId && !this.userId)
                    || (this.userUnit(unit) && this.userId);
            },

            initDrag() {
                if (!this.drag) return;

                // Level 1 drag
                var el = document.getElementById(this.id+'-struct');
                this.sortable = Sortable.create(el, { handle: '.move-1', animation: 150, onUpdate: this.level1Sorted});

                // Level 2 drag
                this.sortables = [];
                for (var index in this.sections) {
                    var section = this.sections[index];
                    var el = document.getElementById(this.id+'-struct-'+section.id);
                    this.sortables[section.id] = Sortable.create(el, { 
                        handle: '.move-2', animation: 150, group: 'level-2', onUpdate: this.level2Sorted, onAdd: this.level2Added
                    });
                }
            },
            
            level1Sorted(event) {
                var data = {id: event.item.dataset.id, order: event.newIndex};
                this.itemSorted(data);
            },

            level2Sorted(event) {
                var data = {id: event.item.dataset.id, order: event.newIndex, section_id: event.to.dataset.id};
                this.itemSorted(data);
            },

            level2Added(event) {
                var data = {id: event.item.dataset.id, order: event.newIndex, section_id: event.to.dataset.id};
                this.itemSorted(data);
            },

            addUnit(event, sectionId, data = {}) {
                data.phase_id = this.indexId
                data.section_id = sectionId
                if (!data.meta) data.meta = {}

                // Always force the target context: a duplicated or pasted session may come from
                // another program, another registration or another learner.
                data.registration_id = this.registrationId ? this.registrationId : null;
                data.user_id = this.userId ? this.userId : null;
                this.bus.$emit(this.id+'-edit-create', data);
                this.bus.$emit(this.id+'-edit-open', {title: this.newUnitLabel} );
            },
            
            addSection(event) {
                var data = {phase_id: this.indexId};
                this.bus.$emit(this.id+'-edit-create', data );
                this.bus.$emit(this.id+'-edit-open', {title: this.newCategoryLabel} );
            },

            editUnit(event, unit) {
                if (!this.editAllowed) return;
                this.bus.$emit(this.id+'-edit-update', unit);
            },

            editMore(event, id) {
                if (this.editUrlMap) {
                    var unit = this.learningUnit(id);
                    var propVal = unit[this.editUrlMap.prop];
                    var url = unit.meta.assessment ? this.editUrlMap.assess_map[propVal] : this.editUrlMap.map[propVal];
                    window.location = url + '/' + id;
                }  
            },

            canEditMore(id) {
                if (this.editUrlMap) {
                    var unit = this.learningUnit(id);
                    var propVal = unit[this.editUrlMap.prop];
                    if (this.editUrlMap.map[propVal]) return true;
                    if (unit.meta.assessment && this.editUrlMap.assess_map[propVal]) return true;
                }
            },

            getData() {
                var that = this;
                axios.get(this.endpoint, {params: that.params})
                    .then(function (response) {
                        that.sections = response.data.data;
                        that.loaded = true;
                    })
                    .catch(function (error) {
                    });
            },

            itemSorted(data) {
                var item = data.section_id ? this.learningUnit(data.id) : this.section(data.id);
                item.order = data.order;
                if (data.section_id) {
                    item.section_id = data.section_id;
                    item.endpoint = this.learningUnitsEndpoint;
                } else {
                    item.endpoint = this.endpoint;
                }
                this.bus.$emit(this.id+'-edit-send', item);
            },

            learningUnit(id) {
                for (var index in this.sections) {
                    var section = this.sections[index];
                    if (!section.learning_units) continue;
                    for (var index2 in section.learning_units) {
                        var unit = section.learning_units[index2];
                        if (unit.id == id) return unit;
                    }
                }
            },

            section(id) {
                for (var index in this.sections) {
                    var section = this.sections[index];
                    if (section.id == id) return section;
                }
            },

            deleteUnit(event, unit) {
                this.bus.$emit(this.id+'-delete-open', {data: unit});
            },

            deleteUnitConfirmed(unit) {
                var that = this;
                let endpoint = unit.section_id ? this.learningUnitsEndpoint : this.endpoint
                axios.delete(endpoint+'/'+unit.id, {params: that.endpointParams})
                    .then(function (response) {
                        that.refresh();
                    })
                    .catch(function (error) {
                        if (typeof error.response.data == 'string') {
                            that.bus.$emit(that.id+'-toastr-error', error.response.data);
                        }
                        if (typeof error.response.data.message == 'string') {
                            that.bus.$emit(that.id+'-toastr-error', error.response.data.message);
                        }
                    });
            },

            copyUnit(event, unit) {
                localStorage.setItem('clipboard_learningunit', JSON.stringify(unit))
            },

            pasteUnitInSection(section) {
                let data = JSON.parse(localStorage.getItem('clipboard_learningunit'))
                if (data) {
                    data.origin_id = data.id
                    delete data.id
                    this.addUnit(null, section.id, data)
                }
            },

            duplicateUnit(event, unit) {
                let data = {...unit}
                data.origin_id = data.id
                delete data.id
                this.addUnit(event, unit.section_id, data)
            },

            refresh() {
                this.getData();
            }
        }
    }
</script>

<style scoped>
    
    /* Fixed the z-index of dropdown inside buttons */
    .btn {
        will-change: auto;
    }
    .btn-dropdown {
        top: 0px;
        left: 0px;
        width: 20px;
        height: 15px;
    }
    .btn-actions {
        position: absolute;
        top:0;
        width:100%;
        height:15px;
    }
    .btn .dropdown-item {
        text-transform: none;
    }
    .btn .dropdown-item:hover {
        color: #fff;
    }

</style>